{
  "name": "projectchrono",
  "version": "0.0.13",
  "scripts": {
    "e2e": "ng e2e",
    "e2e:test": "./node_modules/.bin/nightwatch --env 'firefox' --config './nightwatch.conf.js'",
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "npx ng lint",
    "storybook": "ng run projectchrono:storybook",
    "build-storybook": "ng run projectchrono:build-storybook"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.2",
    "@angular/cdk": "^19.2.3",
    "@angular/common": "^19.2.2",
    "@angular/compiler": "^19.2.2",
    "@angular/core": "^19.2.2",
    "@angular/forms": "^19.2.2",
    "@angular/material": "^19.2.3",
    "@angular/platform-browser": "^19.2.2",
    "@angular/platform-browser-dynamic": "^19.2.2",
    "@angular/router": "^19.2.2",
    "@apollo/client": "^3.13.4",
    "@ng-select/ng-select": "^14.2.3",
    "@tailwindcss/postcss": "^4.0.17",
    "apollo-angular": "^10.0.3",
    "echarts": "^5.6.0",
    "exceljs": "4.4.0",
    "graphql": "^16.10.0",
    "html2canvas": "1.4.1",
    "jspdf": "3.0.0",
    "loglevel": "1.9.2",
    "ngx-echarts": "^19.0.0",
    "postcss": "^8.5.3",
    "rxjs": "~7.8.2",
    "svg2pdf.js": "^2.4.0",
    "tailwindcss": "^4.0.17",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.3",
    "@angular-eslint/builder": "19.2.1",
    "@angular-eslint/eslint-plugin-template": "19.2.1",
    "@angular-eslint/schematics": "19.2.1",
    "@angular-eslint/template-parser": "19.2.1",
    "@angular/cli": "^19.2.3",
    "@angular/compiler-cli": "^19.2.2",
    "@angular/localize": "^19.2.2",
    "@chromatic-com/storybook": "^3.2.5",
    "@compodoc/compodoc": "^1.1.26",
    "@eslint/js": "^9.22.0",
    "@nightwatch/angular": "3.1.1",
    "@nightwatch/schematics": "^1.2.1",
    "@playwright/test": "^1.51.0",
    "@storybook/addon-docs": "^8.6.4",
    "@storybook/addon-essentials": "^8.6.4",
    "@storybook/addon-interactions": "^8.6.4",
    "@storybook/angular": "^8.6.4",
    "@storybook/blocks": "^8.6.4",
    "@storybook/test": "^8.6.4",
    "@types/echarts": "^4.9.22",
    "@types/jasmine": "~5.1.7",
    "@types/nightwatch": "2.3.32",
    "@types/node": "22.13.10",
    "@typescript-eslint/eslint-plugin": "8.26.1",
    "@typescript-eslint/parser": "8.26.1",
    "angular-eslint": "19.2.1",
    "eslint": "9.22.0",
    "eslint-plugin-storybook": "0.11.4",
    "geckodriver": "5.0.0",
    "globals": "^16.0.0",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "storybook": "^8.6.4",
    "ts-node": "10.9.2",
    "typescript": "~5.7.3",
    "typescript-eslint": "8.26.1"
  }
}
